import { z } from 'zod'

export const yardiGuestSearchSchema = z.object({
  org_id: z.string().optional(),
  company_id: z
    .string()
    .min(1, 'Company is required.')
    .regex(/^\d+$/, 'Company is required.'),
  property_id: z
    .string()
    .min(1, 'Property is required.')
    .regex(/^\d+$/, 'Property is required.'),
  first_name: z.string().optional().refine((v) => !v || v.length >= 2, {
    message: 'First Name Must be 2 characters long.',
  }),
  last_name: z.string().optional().refine((v) => !v || v.length >= 2, {
    message: 'Last Name Must be 2 characters long.',
  }),
  email_address: z.string().optional().refine((v) => !v || v.length >= 2, {
    message: 'Email Must be 2 characters long.',
  }),
  phone_number: z.string().optional().refine((v) => !v || v.length >= 7, {
    message: 'Phone Number Must be 7 characters long.',
  }),
  /** Stored as YYYY-MM-DD (DatePicker / native date; API same as Angular) */
  date_of_birth: z.string().optional(),
  third_party_id: z.string().optional(),
  federal_id: z.string().optional(),
  join_filter_items_with_and: z.boolean(),
})
